// extracted by mini-css-extract-plugin
export var button__products = "OpenAndClose-module--button__products--09ece";
export var container = "OpenAndClose-module--container--0d504";
export var rotate = "OpenAndClose-module--rotate--acfd8";
export var rotate2 = "OpenAndClose-module--rotate2--64139";